import React, { memo } from 'react';
import { useTheme } from '@mui/material/styles';
import { Tooltip, TableCell } from '@mui/material';
import CakeIcon from '@mui/icons-material/Cake';
import utils from 'components/utils';

const GadgetComp = ({ classes, type, width }) => {
	const theme = useTheme();
	const translate = utils.useI18N();

	const w = {
		width,
		maxWidth: width,
		minWidth: width
	};

	return (
		<TableCell style={w} sx={{ padding: '16px 16px 16px 0 !important' }}>
			{type == 9 && (
				<Tooltip title={translate('common.gadget')}>
					<CakeIcon sx={{ color: theme.palette.primary.main }} />
				</Tooltip>
			)}
		</TableCell>
	);
};

const Gadget = memo(
	({ item, width }) => <GadgetComp type={item.type} width={width} />,
	(p, n) => p.item.type === n.item.type
);

export default Gadget;
